/**
 * Strip the display-only sibling letter and surrounding whitespace so a
 * `S-00001092B` resolves to the stored `S-00001092`.
 *
 * This is the ONLY piece of booking-number logic the admin UI owns. Whether a
 * problem report belongs to a booking is decided once, in the backend
 * (`backend/src/core/modules/common/damagereport/damageReportBookingMatch.ts`),
 * and delivered as `booking.damageReports` — the same field the bookings
 * list's "Problem" column has always rendered. The frontend reads that answer
 * instead of forming a second opinion about it.
 *
 * The cross-deployable copy of this normalisation is
 * `backend/src/core/utils/bookingNumberUtil.ts`, which strips ALL trailing
 * ASCII letters case-insensitively. This one strips a single trailing
 * uppercase letter, which is what the admin UI has always applied. Change one,
 * look at the other.
 */
export const normalizeBookingNumber = (value?: string | null): string =>
    (value ?? '').trim().replace(/[A-Z]$/, '');
